import { type Client, ClientProviderEvents } from '@openfeature/web-sdk';
import { useCallback, useEffect, useState } from 'react';

import { openFeatureFlag } from '../lib/OpenFeatureFlagConnector';

export const useFeatureClient = (): Client => {
  const [openFeatureClient, setOpenFeatureClient] = useState<Client>(
    openFeatureFlag.getClient(),
  );
  const handleContextChange = useCallback(() => {
    setOpenFeatureClient(openFeatureFlag.getClient());
  }, []);

  useEffect(() => {
    setOpenFeatureClient(openFeatureFlag.getClient());
  }, []);

  useEffect(() => {
    openFeatureFlag.addHandler(
      ClientProviderEvents.ContextChanged,
      handleContextChange,
    );

    return () => {
      openFeatureFlag.removeHandler(
        ClientProviderEvents.ContextChanged,
        handleContextChange,
      );
    };
  }, [handleContextChange]);

  return openFeatureClient;
};
